import { useState, useEffect } from 'react';
import { trackEvent } from '../../../utils/analytics';

const navLinks = [
  { href: 'prodotti', label: 'Prodotti' },
  { href: 'tecnica', label: 'Tecnica' },
  { href: 'form', label: 'Preventivo' },
];

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, id: string, label?: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMobileOpen(false);
    if (label) trackEvent('nav_click', label, 'navbar');
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        scrolled ? 'bg-white border-b border-[#A5A5A5]/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-3.5 flex items-center justify-between">
        <a href="#hero" onClick={(e) => handleNav(e, 'hero')}>
          <img
            src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/81e3031b4bcc562bb081a6ae4aa9af2c.png"
            alt="Punto Cassonetti"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop menu */}
        <div className="hidden md:flex items-center gap-7 text-xs font-semibold uppercase tracking-widest" style={{ fontFamily: "'DM Sans', sans-serif" }}>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={`#${link.href}`}
              onClick={(e) => handleNav(e, link.href, link.label)}
              className={`transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'text-[#A5A5A5] hover:text-[#000000]' : 'text-white/60 hover:text-white'}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+390519981801"
            onClick={() => trackEvent('phone_click', '051 9981801', 'navbar')}
            className="flex items-center gap-2 px-4 py-2 rounded-md transition-colors whitespace-nowrap text-xs bg-[#7FCDCD] text-white hover:bg-[#6bbaba] font-bold"
          >
            <i className="ri-phone-fill text-xs"></i>
            051 9981801
          </a>
        </div>

        {/* Mobile — CTA preventivo visibile nella top nav */}
        <div className="md:hidden">
          <a
            href="#form"
            onClick={(e) => handleNav(e, 'form', 'Preventivo')}
            className={`flex items-center gap-1.5 text-xs font-black px-4 py-2 rounded-full whitespace-nowrap cursor-pointer transition-all ${
              scrolled
                ? 'bg-[#7FCDCD] text-white'
                : 'bg-white/15 text-white border border-white/25'
            }`}
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            <i className="ri-file-list-3-line text-xs" />
            Preventivo
          </a>
        </div>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-[#F6F6F6] px-5 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={`#${link.href}`}
              onClick={(e) => handleNav(e, link.href, link.label)}
              className="text-sm font-semibold text-[#000000] py-2 border-b border-[#F6F6F6] cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
